<template>
  <b-datetimepicker
    ref="datePicker"
    v-bind="$attrs"
    :value="value"
    :initial-value="initialValue"
    icon="calendar-today"
    @input="changeDate($event)"
    :required="required"
    :placeholder="placeholder">
  </b-datetimepicker>
</template>

<script>
import validatable from '@/mixins/validatable.js'

export default {
  props: {
    value: {},
    initialValue: {
      default: () => new Date()
    },
    required: {
      type: Boolean
    },
    placeholder: {
      type: [Number, String]
    }
  },
  mixins: [validatable],
  computed: {
    dateValue(value) {
      return value ? value : new Date();
    }
  },
  mounted() {
    this.fixCalendarIcon();
  },
  methods: {
    changeDate(v) {
      this.$emit("input", v);
      this.validate(v);
    },
    fixCalendarIcon() {
      const el = this.$refs.datePicker.$el;

      // Change mdi icon to font awesome icon for calendar;
      const todayIcon = el.querySelector(".mdi-calendar-today");
      if (todayIcon) {
        todayIcon.setAttribute(
          "class", "fas fa-calendar-alt"
        );
      }

      const left = el.querySelector(".mdi-chevron-left");
      left.setAttribute("class", "fas fa-chevron-left");
      left.parentNode.classList.remove("has-text-primary");
      left.parentNode.parentNode.style.paddingLeft = '0.5em';
      left.parentNode.parentNode.style.paddingRight = '0.5em';

      const right = el.querySelector(".mdi-chevron-right");
      right.setAttribute("class", "fas fa-chevron-right");
      right.parentNode.classList.remove("has-text-primary");
      right.parentNode.parentNode.style.paddingLeft = '0.5em';
      right.parentNode.parentNode.style.paddingRight = '0.5em';
    }
  }
}
</script>

<style scoped lang="scss">
.pagination-left, .pagination-right {
  padding-left: 0.5em !important;
  padding-right: 0.5em !important;
}
</style>
